export function categorizeCommunities(data: any[]) {
  return {
    communities: data,
    certificationCommunities: data.filter((community: any) => {
      return community.Category == "Professional/Expert";
    }),
    associateCommunities: data.filter((community: any) => {
      return community.Category == "Associate";
    }),
    moreCommunities: data.filter((community: any) => {
      return (
        community.Category != "Professional/Expert" &&
        community.Category != "Associate"
      );
    }),
    communitythreads: data.filter((community: any) => {
      return (
        community.Id === "0TO3i00000094ZjGAI" ||
        community.Id === "0TO3i0000008jYHGAY"
      );
    }),
    communitytop: data.filter((community: any) => {
      return community.Id === "0TO3i0000008jYHGAY";
    }),
    communitybottom: data.filter((community: any) => {
      return community.Id === "0TO3i00000094ZjGAI";
    }),
  };
}
